{
	"title": "{{productName}} historie transakcí",
	"item": {
		"time": "Čas",
		"description": "Popis",
		"transactionId": "ID transakce",
		"showIds": "Zobrazit ID",
		"depositTitle": "Zajištění od DNV, umožňující vklad uhlíkové banky",
		"depositDescription": "Jakmile zajišťovací orgán třetí strany „DNV“ ujistil uložené množství zachyceného uhlíku v digitálním systému Monitor-Report-Verify, je v uhlíkové bance vytvořen nový vklad.",
		"withdrawalTitle": "Faktura dodavateli, která spustí výběr z uhlíkové banky",
		"withdrawalDescription": "S fakturací materiálu evoZero dodavateli byl proveden výběr z uhlíkové banky.",
		"transferTitle": "Převod snížení emisí uhlíku držiteli prohlášení",
		"transferDescription": "Dodavatel inicioval převod uhlíkových redukcí držiteli deklarace na základě objemu materiálu evoZero, který byl vložen do dodaného produktu."
	},
	"proofIdsModal": {
		"titleTransactions": "Zobrazit transakce",
		"titleMeasurements": "Zobrazit měření",
		"paragraph1": "Jeden krok transakce na {{productName}} zahrnuje agregaci transakcí v distribuované účetní knize. Níže naleznete seznam odkazů na služby třetích stran, kde si tyto transakce můžete prohlédnout.",
		"paragraph2": "Vezměte prosím na vědomí, že tyto odkazy vás zavedou na externí webové stránky, které poskytují možnosti zobrazení transakcí.",
		"open": "Otevřít",
		"close": "Zavřít"
	},
	"errors": {
		"fetch": "Historii aktivit se nepodařilo načíst"
	}
}
